import * as Yup from 'yup';

const schema = Yup.object().shape({
  Name: Yup.string().required('O campo deve ser preenchido'),
  Type: Yup.string().required('O campo deve ser preenchido'),
  Address: Yup.string().required('O campo deve ser preenchido'),
});

export default schema;
